export default __webpack_public_path__ + "static/B0168-5dcfac8b4433f8573b06de0e5133ee2b.png";